import { NON_DEER_ROUTES } from 'Deer/constants/nonDeerRoutes';
import { useParsedQuery } from 'components/hooks/useParsedQuery';
import { matchPath, useLocation } from 'react-router-dom';

export const useNonDeerRouteDetails = () => {
  const location = useLocation();

  // specifically for the case of review result page
  const { source } = useParsedQuery();

  const matchedRoute = Object.values(NON_DEER_ROUTES).find(({ route }) =>
    matchPath(location.pathname, { path: route, exact: false })
  );

  // special case for review result page as the route in non deer and l1 can only be determined by query param
  if (matchedRoute?.label === NON_DEER_ROUTES.reviewsResultPage.label) {
    let l1Module = 'myData';
    if (['allReports', 'directReports', 'view'].includes(source)) {
      l1Module = 'team';
    }
    if (source === 'company') {
      l1Module = 'company';
    }
    return {
      ...matchedRoute,
      l1Module,
    };
  }

  if (typeof matchedRoute?.hasSidePanel === 'function') {
    return {
      ...matchedRoute,
      hasSidePanel: matchedRoute.hasSidePanel(),
    };
  }

  return matchedRoute;
};
